<template>
  <div class="basic_wrap">
    <!-- ================= 顶部标题 ================= -->
    <div class="page_header">
      <div class="header_title">{{ $t('home.invest') || '投资' }}</div>
    </div>

    <!-- ================= 顶部分类 Tab ================= -->
    <div class="tabs_container" v-if="tabs && tabs.length > 0">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab_item"
        :class="{ 'tab_active': active === tab.id }"
        @click="qiehuan(tab.id)"
      >
        {{ tab.title }}
      </div>
    </div>

    <!-- ================= 产品列表 ================= -->
    <div class="main_content">
      
      <!-- 数据加载中 -->
      <div v-if="loading && list.length === 0" class="loading_tip">loding...</div>

      <!-- 列表为空 -->
      <div v-else-if="!loading && list.length === 0" class="empty_tip">not data</div>
      
      <!-- 单个产品卡片循环 -->
      <div 
        class="card_box project_card" 
        v-for="(item, index) in list" 
        :key="index"
        
      >
        <!-- 卡片头部 -->
        <div class="project_top">
          <div class="proj_title">{{ item.title }}</div>
        </div>

        <!-- 内容区 (左图右标签) -->
        <div class="project_body">
          <div class="proj_img">
            <img :src="item.img" alt="cover">
          </div>
          <div class="proj_tags">
            <span class="tag vip">{{ item.level_name }}</span>
            <span class="tag auto">{{ $t('utils.lunlog50') }}</span>
            <span class="tag safe">{{ $t('utils.lunlog49') }}</span>
          </div>
        </div>

        <!-- 2x3 数据表格 -->
        <div class="proj_data_grid">
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{ item.newmin }}</div>
            <div class="data_label">{{ $t('index.amount') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{ item.fan }}</div>
            <div class="data_label">{{ $t('utils.lunlog31') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val">
              <span v-if="item.type == 3">{{ item.day }}{{ $t('index.hour') }}</span>
              <span v-else>{{ item.day }}{{ $t('index.day') }}</span>
            </div>
            <div class="data_label">{{ $t('index.cycle') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val blue">{{ item.rate }}%</div>
            <div class="data_label">{{ $t('index.rate') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val">{{ common.currency_symbol_basic() }}{{ item.days }}/{{ $t('index.day') }}</div>
            <div class="data_label">{{ $t('invest.income') }}</div>
          </div>
          <div class="data_item">
            <div class="data_val black">{{ common.currency_symbol_basic() }}{{ item.zong }}</div>
            <div class="data_label">{{ $t('utils.goodszong') }}</div>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="project_btn" @click="$router.push('/invest/detail/'+item.id)">
          {{ $t('utils.lunlog29') }}
        </div>
      </div>

      <!-- 列表底部占位 -->
      <div style="height: 80px;"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';

export default {
  name: "Invest",
  data() {
    return {
      active: 0,       // 当前选中的分类ID
      tabs: [],        // 分类列表 (来自 item_class)
      list: [],        // 产品列表 (来自 item_list)
      page: 1,
      listRows: 8,
      loading: false,
      finished: false,
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FAFAFA');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('invest', true);
  },
  mounted() {
    // 先加载分类，拿到分类后默认请求第一个分类的产品列表
    this.getClassList();
  },
  methods: {
    // 1. 获取分类接口
    getClassList() {
      Fetch('/index/item_class').then((r) => {
        if (r.data.classes && r.data.classes.length > 0) {
          this.tabs = r.data.classes;
          // 默认选中第一个分类的ID
          this.active = this.tabs[0].id;
          // 拿到默认分类后，请求对应的产品列表
          this.getProductList();
        }
      });
    },

    // 2. 获取产品列表接口 (根据当前 active ID 和 page)
    getProductList() {
      if (this.loading) return;
      
      this.loading = true;
      Fetch('/index/item_list', {
        page: this.page,
        listRows: this.listRows,
        type: this.active // 传入当前选中的分类ID
      }).then(r => {
        this.loading = false;
        let newData = r.data.list || [];
        
        if (newData.length === 0) {
          this.finished = true;
          return;
        }
        
        // 如果是第一页，直接覆盖；否则追加
        if (this.page === 1) {
          this.list = newData;
        } else {
          this.list = this.list.concat(newData);
        }
        
        // 如果当前页数量小于每页数量，说明数据加载完了
        if (newData.length < this.listRows) {
          this.finished = true;
        } else {
          this.page += 1;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    // 3. 切换分类
    qiehuan(id) {
      if (this.active === id) return; // 防止重复请求
      
      this.active = id;
      this.page = 1;          // 重置为第一页
      this.list = [];         // 清空当前列表
      this.finished = false;  // 重置加载完成状态
      this.getProductList();  // 重新请求新分类的数据
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
 background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
  padding-bottom: 20px;
}

/* 顶部标题 */
.page_header {
  padding: 20px 0 12px;
  text-align: center;
  background: transparent;
  .header_title {
    font-size: 20px;
    font-weight: 700;
    color: #111;
  }
}

/* 顶部加载和空状态提示 */
.loading_tip, .empty_tip {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

/* 分类 Tab (类似截图中的每日收入/稳定收入) */
.tabs_container {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 0 16px;
  margin-bottom: 16px;
  
  .tab_item {
    flex: 1;
    max-width: 160px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 22px;
    font-size: 15px;
    font-weight: 600;
    background: #ffffff;
    color: #e50914; /* 默认红色文字 */
    cursor: pointer;
    border: 1px solid #e5e7eb;
    transition: all 0.25s ease;
    
    &:active { transform: scale(0.96); }
    
    &.tab_active {
      background: #2563eb; /* 选中为蓝色背景 */
      color: #ffffff;
      border-color: #2563eb;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }
  }
}

/* 主体内容 */
.main_content {
  padding: 0 16px;
}

/* 投资产品卡片 */
.project_card {
  background: #ffffff;
  border-radius: 18px;
  padding: 20px 16px 16px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  margin-bottom: 16px;
  border: 1px solid rgba(176, 202, 240, 0.3);
  cursor: pointer;
  transition: transform 0.2s;
  
  &:active { transform: scale(0.98); }
}

/* 1. 卡片标题 */
.project_top {
  text-align: center;
  margin-bottom: 14px;
  .proj_title {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
}

/* 2. 左图右标签区 */
.project_body {
  display: flex;
  gap: 14px;
  margin-bottom: 16px;
  
  .proj_img {
    width: 86px;
    height: 86px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f5f5f5;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .proj_tags {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    
    .tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      width: fit-content;
      background: #fef7ec;
      color: #b45309;
      font-size: 12px;
      font-weight: 600;
      padding: 3px 10px;
      border-radius: 14px;
      
      &.vip { background: #fef3c7; color: #b45309; }
      &.auto { background: #d1fae5; color: #047857; }
      &.safe { background: #fefce8; color: #a16207; }
      
      .icon { font-size: 12px; }
    }
  }
}

/* 3. 2x3 数据网格 */
.proj_data_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
  
  .data_item {
    background: #f6f9ff;
    border-radius: 10px;
    padding: 10px 0;
    text-align: center;
    
    .data_val {
      font-size: 14px;
      font-weight: 700;
      color: #000;
      margin-bottom: 4px;
      &.blue { color: #1d4ed8; }
      &.black { color: #333; }
    }
    .data_label {
      font-size: 12px;
      color: #777;
    }
  }
}

/* 4. 底部按钮 */
.project_btn {
  width: 100%;
  height: 44px;
  background: #2563eb;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  transition: opacity 0.2s;
  &:active { opacity: 0.8; }
}
</style>